import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import "@/assets/less/animation.css";
import PhotoCard from "@/components/common/PhotoCard";
export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag: JDictSelectTag,
    PhotoCard: PhotoCard
  },
  data: function data() {
    return {
      dataSource: [],
      pagination: {
        onChange: function onChange(page) {
          console.log(page);
        },
        pageSize: this._isMobile() ? 8 : 12
      },
      loading: true,
      productType: "",
      tenantConfig: {},
      videoVisible: false,
      currentItem: {},
      queryParam: {}
    };
  },
  created: function created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.getList();
  },
  mounted: function mounted() {},
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      this.dataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsType: 7,
        pageSize: 999,
        cmsStatus: 1
      }).then(function (res) {
        console.log(res);
        if (res.success) {
          _this.dataSource = res.result.records;
        }
        _this.loading = false;
      });
    },
    toDetail: function toDetail(item) {
      var route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id
        }
      });
      window.open(route.href, '_blank');
    }
  }
};